export default __webpack_public_path__ + "static/Image-Helping-Our-Neighbors-Find-Homes-8bee13142e4f91299a2b79b94e07a298.jpg";